import styled, { css } from 'styled-components';
import { BaseAttributeSelector } from '../BaseAttributeSelector/index';
export const StyledSizeSelector = styled(BaseAttributeSelector) `
  margin-top: 0;
  margin-bottom: -8px;
  margin-inline-start: 0;
  margin-inline-end: -8px;

  ${o => o.$columns &&
    css `
      display: grid;
      grid-template-columns: ${`repeat(${o.$columns}, 1fr)`};
    `}
`;
//# sourceMappingURL=styles.js.map